import { Controller } from "stimulus"
import $ from 'jquery'

export default class extends Controller {
  static targets = ['form']

  submitForm(event) {
    let [isValid, requiredFields] = this.validateForm(this.formTarget);

    if (!isValid) {
      event.preventDefault();
      requiredFields[0].focus()
    }
  }

  validateForm() {
    let isValid = true;
    let requiredFieldSelectors = 'textarea:required, input:required, select:required';
    let requiredFields = this.formTarget.querySelectorAll(requiredFieldSelectors);

    requiredFields.forEach((field) => {
      if (!field.disabled && !field.value.trim()) {
        $(field).addClass('is-invalid')

        if (!$(field).parent().children().hasClass('invalid-feedback')) {
          let label = $(field).parent().find('label').text().slice(0, -2)
          $(field).parent().append(`<div class="invalid-feedback">${label} can\'t be blank</div>`)
        }

        isValid = false;
      }
      else {
        $(field).removeClass('is-invalid')
        $(field).parent().find('.invalid-feedback').remove()
      }
    });

    return [isValid, requiredFields];
  }
}